import { NotifyHelper } from "../../../helpers/toast";
import { eDonViTinhActionTypeDefine } from "../../action-types/category/IDonViTinhActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const donViTinhActions = {
    ...generateActions(eDonViTinhActionTypeDefine, "DON_VI_TINH"),
    ...generateActionForKey(eDonViTinhActionTypeDefine, "DON_VI_TINH", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDonViTinhActionTypeDefine, "DON_VI_TINH", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eDonViTinhActionTypeDefine, "DON_VI_TINH", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eDonViTinhActionTypeDefine, "DON_VI_TINH", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}